import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCryptosAPI = (authHeaders) => 
  axios.get(`${API_BASE_URL}/api/cryptos`, authHeaders);

export const fetchPortfolioAPI = (authHeaders) => 
  axios.get(`${API_BASE_URL}/api/trade/portfolio`, authHeaders);

export const fetchOrdersAPI = (authHeaders) => 
  axios.get(`${API_BASE_URL}/api/trade/orders`, authHeaders);

export const triggerLimitOrderAPI = (orderId, executionPrice, authHeaders) =>
  axios.post(`${API_BASE_URL}/api/trade/order/trigger-limit`, { orderId, executionPrice }, authHeaders);

export const triggerSLTPAPI = (coinId, triggerType, executionPrice, authHeaders) =>
  axios.post(`${API_BASE_URL}/api/trade/position/trigger-sl-tp`, { coinId, triggerType, executionPrice }, authHeaders);

export const placeOrderAPI = (orderPayload, authHeaders) =>
  axios.post(`${API_BASE_URL}/api/trade/order`, orderPayload, authHeaders);

export const cancelOrderAPI = (orderId, authHeaders) =>
  axios.post(`${API_BASE_URL}/api/trade/order/cancel`, { orderId }, authHeaders);

export const closePositionAPI = (coinId, executionPrice, authHeaders) =>
  axios.post(`${API_BASE_URL}/api/trade/position/close`, { coinId, executionPrice }, authHeaders);

export const updateSLTPAPI = (coinId, stopLoss, takeProfit, authHeaders) =>
  axios.post(`${API_BASE_URL}/api/trade/position/update-sl-tp`, { coinId, stopLoss, takeProfit }, authHeaders);

export const resetAccountAPI = (authHeaders) =>
  axios.post(`${API_BASE_URL}/api/trade/reset`, undefined, authHeaders);

export const fetchDailyPnLAPI = (month, authHeaders) => {
  const params = month ? { month: month.toISOString() } : {};
  return axios.get(`${API_BASE_URL}/api/trade/pnl/daily`, { ...authHeaders, params });
};
